import logo from "assets/images/saturncube-logo.png";

// ==============================|| LOGO SVG ||============================== //

const Logo = (props) => {

  const { height, width } = props;

  return (
    <img src={logo} alt="company-logo" style={{ width: width ? width : "228px", height: height ? height : "auto" }} />
  );
};

export default Logo;
